<template>
  <RemotePaginatedList
    :filter-options="filterOptions"
    :headers="headers"
    multi-datasett
    v-model="selectedItemIds"
    data-url="admin/dataset/ignore_sync_list/"
    data-key="ignore_sync_list"
    :refresh-trigger.sync="innerRefreshTrigger"
    v-bind="$attrs"
    class="ignore-sync-list"
  >
    <template #item.period="{ value }">
      {{ $parsePeriod(value) }}
    </template>
    <template #item.removed_by="{ value }">
      {{ value.name }}
    </template>
    <template #item.removed_at="{ value }">
      <span>{{ value ? $parseDate(value, "yyyy-MM-dd HH:mm") : "-" }}</span>
    </template>
    <template v-slot:item.actions="{ item }">
      <div class="d-flex">
        <v-btn
          v-if="canDelete"
          text
          color="primary"
          @click="removeFromIgnoreList(item)"
        >
          Remove from Ignore List
        </v-btn>
      </div>
    </template>
  </RemotePaginatedList>
</template>

<script>
import { onMounted, ref, watch, computed } from "@vue/composition-api";
import RemotePaginatedList from "@/components/RemotePaginatedList";
import _ from "lodash";
import { ACTION_TYPES } from "@/store/types";
import { USER_TYPE, PERMISSIONS } from "@/constants";

export default {
  name: "DatasetIgnoreList",
  components: { RemotePaginatedList },
  props: {
    value: Array,
    refreshTrigger: Boolean,
  },
  setup(props, { root, emit }) {
    const refresh = function () {
      innerRefreshTrigger.value = true;
    };
    const canDelete = computed(() => {
      if (!root.$store.getters.account) return false;
      return (
        [USER_TYPE.SUPER_ADMIN].includes(root.$store.getters.account.type) ||
        _.some([PERMISSIONS.MANAGE_RBU_DATASET], (p) =>
          root.$store.getters.hasPermission(p)
        )
      );
    });
    onMounted(() => {
      refresh(false);
    });

    watch(
      () => props.refreshTrigger,
      (newValue) => {
        if (newValue) {
          refresh(true);
          emit("update:refresh-trigger", false);
        }
      }
    );

    // Filter
    const filterOptions = ref([]);

    // Data Table
    const headers = ref([
      { text: root.$t("dataset_issue.period"), value: "period" },
      {
        text: "Data Type",
        value: "data_type",
      },
      { text: "Removed By", value: "removed_by" },
      { text: "Removed At", value: "removed_at" },
      { text: "", value: "actions", width: 100, sortable: false },
    ]);
    const innerRefreshTrigger = ref(false);

    const selectedItemIds = ref([]);
    watch(
      () => selectedItemIds.value,
      (newValue) => {
        emit("input", newValue);
      }
    );
    watch(
      () => props.value,
      (newValue, oldValue) => {
        if (_.xor(newValue, oldValue).length) {
          selectedItemIds.value = newValue;
        }
      },
      { deep: true, immediate: true }
    );

    const removeFromIgnoreList = async function (item) {
      const result = await root.$dialog.confirm({
        text: `Remove from Ignore List - ${item.data_type} ?`,
      });

      if (result) {
        const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
          url: "admin/dataset/ignore_sync_list/delete/",
          params: { ignore_sync_list_id: item.id },
        });

        await refresh();
      }
    };

    return {
      filterOptions,

      headers,
      innerRefreshTrigger,
      selectedItemIds,

      removeFromIgnoreList,
      canDelete,
    };
  },
};
</script>

<style lang="less">
.dataset-list {
}
</style>
